import { environment_dev } from '../../../environments/environment.dev';

export function getPxdDevEnvironmentFromSubdomain(subdomain: string): any {
  // devNN.printix.dev & pib-chNN-NN.sandbox.printix.dev environments should have the same configuration as devenv,
  // except for the URL endpoints.
  console.log('subdomain', JSON.stringify(subdomain));
  const environment_pxd_dev = JSON.parse(JSON.stringify(environment_dev));
  const replacementKeys = ['appEndpoint', 'checkServerHealth', 'internalTestWaitTime', 'internalTestReturnSetStatusCode',
    'endpointApi', 'endpointCodeExchange', 'endpointLogOut', 'endpointLogInTenantLess', 'endpointLogInWepAppTenant', 'endpointLogInMS',
    'endpointLogInGoogle', 'endpointGetTenantUser', 'endpointFindTenant'];
  replacementKeys.forEach(key => {
    environment_pxd_dev[key] = environment_pxd_dev[key].replace('devenv.printix.net', subdomain);
  });

  // Set the environment prefix like 'environment_pxd_dev01 || environment_pxd_pib-ch01-001'
  environment_pxd_dev.environmentPrefix = 'environment_pxd_' + subdomain.replace('.printix.dev', '');
  return environment_pxd_dev;
}

export function setPxdSubdomainFromUrl(url: string): string {
  // Split the URL into segments
  const urlSegments = url.split('.');
  // Get the index of the segments that contain 'sandbox' or 'printix'
  const sandboxIdx = urlSegments.findIndex(seg => seg === 'sandbox');
  const printixIdx = urlSegments.findIndex(seg => seg === 'printix');

  if (sandboxIdx > 0) {
    return `${urlSegments[sandboxIdx - 1]}.sandbox.printix.dev`
  } else if (printixIdx > 0) {
    return `${urlSegments[printixIdx - 1]}.printix.dev`
  }
  return undefined;
}
